<style>
.sidenav {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  bottom: 0;
  overflow-y: hidden;
  background-color: #fbfbfc;
  overflow-x: hidden;
  transition: 0.5s;
  left: 170px;

  overflow-y: scroll;
  max-height: 100%;
  bottom: 0;
}

.sidenav a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.sidenav a:hover {
  color: #f1f1f1;
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

#main {
  transition: margin-left 0.5s;
  padding: 16px;
}

@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }
  .sidenav a {
    font-size: 18px;
  }
}

.sub-drawer-title {
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 18px;
  align-items: center;
  color: #9c9b9b;
}
</style>


<template>
  <div id="mySidenav" class="sidenav border-r large-screen">
    <div class="text-center">
      <p
        class="sub-drawer-title text-left pl-3 my-9"
        :class="$store.state.user_type == $keys.SUPER_ADMIN ? 'pt-4' : ''"
      >
        {{ $lang.MANAGE }} :
      </p>

      <!-- <img src="@/assets/logo/logo.png" class="drawer-logo" /> -->
    </div>

    <v-list dense nav class="pa-0 drawer_list bg-transparent">
      <div v-for="(item, i) in getDrawerItems" :key="i" class="">
        <v-list-item
          link
          :to="item.url"
          v-if="item.access_by.includes($store.state.user_type)"
          class="border-b py-1"
        >
          <v-list-item-content class="drawer-text my-1">
            {{ item.title }}
          </v-list-item-content>
        </v-list-item>
      </div>

      <div v-for="item in django_panel" :key="item.url" class="">
        <v-list-item
          link
          :href="item.url"
          class="border-b py-1"
          target="_blank"
        >
          <v-list-item-content class="drawer-text my-1">
            {{ item.title }}
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-list>
  </div>
</template>
	<script>
import { mapGetters } from "vuex";
import keys from "@/app-js/keys"
export default {
  data() {
    return {
      drawer: false,
      django_panel: [
        {
          title: "FAQ",
          url: "https://api.themedx.in/admin/master/faqdata/",
          is_active_tab: false,
          access_by: [keys.WAREHOUSE, keys.SUPER_ADMIN],
        },
      ],
    };
  },
  computed: mapGetters({
    getDrawerItems: "secondary_drawer/getDrawerItems",
  }),
  methods: {},
};
</script>